import { TFunction } from 'react-i18next';
import { TextFieldType } from '../../../../types/form';
import { TextFieldValidationOptions } from '../index';
import {
  isValidPostcode,
  isValidInFrontChars,
  isValidEmail,
  isValidFormat,
} from './validators';

export function applyTextValidationOptions<TFieldValues>(
  t: TFunction,
  type: TextFieldType,
  options: TextFieldValidationOptions<TFieldValues> = {},
) {
  const rules = { ...options };

  switch (type) {
    case 'text': {
      rules.setValueAs = (value: string) => value.trim();

      if (rules.inFrontAllowedChars) {
        rules.validate = {
          isInFrontAllowedChars: (value) =>
            isValidInFrontChars(
              value,
              t('site.pricing.validation.error.code.INVALID_CHARACTERS'),
            ),
          ...rules.validate,
        };
      }

      if (rules.postcode) {
        rules.validate = {
          isPostcode: (value) =>
            isValidPostcode(
              value,
              t('site.pricing.validation.error.code.INVALID_POSTCODE'),
            ),
          ...rules.validate,
        };
      }

      if (rules.format) {
        const textFormat = rules.format;

        rules.validate = {
          isValidFormat: (value) =>
            isValidFormat(
              value,
              textFormat,
              t('site.pricing.validation.error.code.INVALID_FORMAT'),
            ),
          ...rules.validate,
        };
      }

      break;
    }

    case 'number': {
      rules.valueAsNumber = true;
      break;
    }

    case 'email': {
      rules.validate = {
        isEmail: (value) =>
          isValidEmail(
            value,
            t('site.pricing.validation.error.code.INVALID_EMAIL'),
          ),
        ...rules.validate,
      };
      break;
    }

    default:
      break;
  }

  return rules;
}
